module.exports = __webpack_public_path__ + "img/k14.f5db35de.jpg";